<template>
  <div v-if="events.length" id="content" class="px2 sm-px3 pt0">
    <ul v-if="!this.$route.params.slug" class="list-reset">
      <li class="border-top" v-for="(event, index) in events" :key="event.id">
        <router-link :to="{ name: 'Anthology', params: { slug: event.slugs[0] }}">
          <div class="clearfix mxn2">
            <div class="col col-1 px2">{{ index + 1 + '.' }}</div>
            <div class="col col-6 px2">
              {{ getText(event.data.title) }}
            </div>
            <div class="col col-5 px2">
              {{ getText(event.data.text.data.title) }} by {{ getText(event.data.text.data.author) }}
            </div>
          </div>
        </router-link>
      </li>
    </ul>

    <div v-else>
      <div v-if="text" class="clearfix p1">
        <div>
          <div class="header clearfix border-bottom py2">
            <div class="col col-6">Katie Paterson: First There is a Mountain</div>
            <div class="col col-6 right-align">{{ getText(event.data.title) }}</div>
          </div>
          <div class="content">
            <div class="center text-title">
            <em>{{ getText(text.data.title) }}</em><br/>
            by {{ getText(text.data.author) }}
            </div>
            <div class="text-content col-8 mx-auto serif" v-html="getHtml(text.data.text)"></div>
            <div id="about-text" class="col-8 mt3 pt3 mx-auto fs-xs" v-html="getHtml(text.data.about)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import { getText, getHtml, processDate } from '@/utils'
import Prismic from 'prismic-javascript'

export default {

  name: 'Anthology',

  data () {
    return {
      text: ''
    }
  },

  components: {
  },

  mounted () {
    // this.triggerLoad()
  },

  computed: {
    ...mapState([
      'apiEndpoint',
      'events',
      'texts'
    ]),
    event () {
      return this.events.find(x => x.slugs[0] === this.$route.params.slug)
    }
    // currentText () {
    //   if (this.$route.params.slug) {
    //     return this.texts[this.$route.params.slu]
    //   }
    // }
    // slug () {
    //   if (this.$route.params.slug) {
    //     return this.$route.params.slug
    //   } else {
    //     return this.$route.path.replace('/','')
    //   }
    // }
  },

  methods: {
    getText,
    getHtml,
    processDate,
    loadText () {
      if (this.text === '') {
        if (this.event) {
          Prismic.getApi(this.apiEndpoint).then((api) => {
            api.getByID(this.event.data.text.id).then((document) => {
              this.text = document
            })
          })
        }
      }
    },
  },

  watch: {
    // '$route' () {
    //   this.loadText(this.slug)
    // }
    events () {
      if (this.$route.params.slug) {
        this.loadText()
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .header {
    position: fixed;
    top: 0;
    padding-top: var(--space-2);
    left: var(--space-3);
    right: var(--space-3);
    background: white;
  }
  .text-title {
    font-size: var(--fs-responsive-xl);
    line-height: 1.2;
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .content {
    margin-top: 6em;
  }
  .page-content {
    margin-top: 10vh;

    h1 {
      font-size: 42px;
      margin-bottom: 10vh;
    }

    .subtle-links >>> a {
      border: none;
    }

    & >>> a {
      border-bottom: 1px solid var(--green);
    }

    & >>> h3 {
      margin-top: 4em;
      padding-top: 0;
      font-family: var(--font-sans);
      border-bottom: 1px solid var(--black);
      padding-bottom: 1em;

      &:first-child {
        margin-top: 0;
      }
    }

    & >>> p.block-img img {
      width: 60%;
      display: block;
      margin: 0 auto;
    }

    & >>> ul {
      list-style: none;
      padding: 0;

      li {
        margin-top: 0.25em;
      }
    }

    .gallery {
      li {
        img {
          max-width: 100%;
          display: block;
          text-decoration: none;
          border: none;
          transition: all 0.2s ease-out;

          &:hover {
            transform: scale(1.03);
          }
        }
      }
    }

    #blueimp-gallery {
      & >>> a.close {
        margin-top: 0em;
        margin-right: 0.1em;
        color: transparent;

        &:before {
          color: var(--green);
          display: block;
          content: "Close";
        }
      }
      & >>> a {
        border-radius: 0;
        color: var(--green);
        background: none;
        text-shadow: none;
        border: none;
      }
    }
  }
</style>
